import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from '@repo-level/core-front';

import { FormGroup } from 'components/form/groups/FormGroup';
import { Input } from 'components/form/Input';
import { required } from 'helpers/validators';
import { OfUnion } from 'types/common';

export const FieldText: FC<
  | OfUnion<Form.MethodField>[Form.MethodFieldType.CardHolder]
  | OfUnion<Form.MethodField>[Form.MethodFieldType.Text]
  | OfUnion<Form.MethodField>[Form.MethodFieldType.CashoutCryptoAddress]
> = ({ fieldName, label, proposedValue, type }) => {
  const { t } = useTranslation();

  const labelToShow = (() => {
    switch (type) {
      case Form.MethodFieldType.CashoutCryptoAddress:
        return t('cashbox:cryptoAddress');
      default:
        return label || fieldName;
    }
  })();

  return (
    <FormGroup marginBottom={8}>
      <Input
        field={fieldName}
        initialValue={proposedValue || undefined}
        animatedPlaceholder={labelToShow}
        validate={required}
      />
    </FormGroup>
  );
};
